module.exports = __webpack_public_path__ + "static/media/slack-logo.831fd1b2.svg";